import type { RefObject } from 'react';
import { fadeTo } from 'util/animation/fade/fade';

interface PardotPdfFormRefs {
  elementRef: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: PardotPdfFormRefs,
): void {
  timeline.fromTo(elementRef.current, {}, {});
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: PardotPdfFormRefs,
): void {
  timeline.add(fadeTo(elementRef.current as HTMLElement));
}
